export const USER_TOKEN_KEY = 'userToken';
export const DODGER_BLUE_HEADER = 'dodgerBlueHeader';
export const EVENT_TITLE = 'eventTitle';
export const INVITATION_CODE = 'invitationCode';
export const INVITED_EVENT_ID = 'invitedEventId';
export const ACTIVE_STATUS = 2;
export const FILE_SIZE_LIMIT = 10000000;
